import store from '@/store';

// 只观察已启动的账号初始化，不由埋点触发查询或重试。
export function getIdentityContext({ timeoutMs = 1000 } = {}) {
  const identity = store.getters['account/identityType'];
  if (identity) return Promise.resolve({ identity_type: identity });
  if (store.state.account.status !== 'loading') {
    return Promise.resolve({ identity_type: 'unlogin' });
  }
  return new Promise((resolve) => {
    const finish = () => {
      clearTimeout(timer);
      unsubscribe();
      resolve({
        identity_type: store.getters['account/identityType'] || 'unlogin',
      });
    };
    const unsubscribe = store.subscribe(() => {
      if (store.state.account.status !== 'loading') finish();
    });
    const timer = setTimeout(finish, timeoutMs);
  });
}
